import { EmittedEvent } from '@spotify-internal/emitter';
import { Event } from '../../../enums/event';
export class LicenseRequestEvent extends EmittedEvent {
    constructor(message) {
        super(Event.KEY_SESSION_MESSAGE, null);
        this.messageType = 'license-request';
        this.message = message;
    }
}
//# sourceMappingURL=license_request_event.js.map